import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIBuyingPatterns extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  // Partner Ask endpoints

  // Get all asks for a partner
  getPartnerAsks = async (partnerId: UUID): Promise<types.PartnerAsk[]> => {
    let res = await this._fetch({
      url: `/buying-patterns/partners/${partnerId}/asks`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Create a new ask for a partner
  postPartnerAsk = async (
    partnerId: UUID,
    { ...body }: types.PartnerAskCreate,
  ): Promise<types.PartnerAsk> => {
    let res = await this._fetch({
      url: `/buying-patterns/partners/${partnerId}/asks`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Update an ask
  putAsk = async (
    askId: UUID,
    { ...body }: types.PartnerAskUpdate,
  ): Promise<types.PartnerAsk> => {
    let res = await this._fetch({
      url: `/buying-patterns/asks/${askId}`,
      method: "PUT",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Delete an ask
  deleteAsk = async (askId: UUID): Promise<types.PartnerAsk> => {
    let res = await this._fetch({
      url: `/buying-patterns/asks/${askId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Product Mapping endpoints

  // Get all product mappings for an ask
  getAskProducts = async (
    askId: UUID,
  ): Promise<types.PartnerAskProductMapping[]> => {
    let res = await this._fetch({
      url: `/buying-patterns/asks/${askId}/products`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Add a product mapping to an ask
  postAskProduct = async (
    askId: UUID,
    { ...body }: types.PartnerAskProductMappingCreate,
  ): Promise<types.PartnerAskProductMapping> => {
    let res = await this._fetch({
      url: `/buying-patterns/asks/${askId}/products`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Update a product mapping
  putProductMapping = async (
    mappingId: UUID,
    { ...body }: types.PartnerAskProductMappingUpdate,
  ): Promise<types.PartnerAskProductMapping> => {
    let res = await this._fetch({
      url: `/buying-patterns/products/${mappingId}`,
      method: "PUT",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Delete a product mapping
  deleteProductMapping = async (
    mappingId: UUID,
  ): Promise<types.PartnerAskProductMapping> => {
    let res = await this._fetch({
      url: `/buying-patterns/products/${mappingId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
